import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import type React from 'react';
import { createContext, useContext } from 'react';
import { cn } from '../../../shared/cn';
const sizes = {
  xs: 'sm:max-w-xs',
  sm: 'sm:max-w-sm',
  md: 'sm:max-w-md',
  lg: 'sm:max-w-lg',
  xl: 'sm:max-w-xl',
  '2xl': 'sm:max-w-2xl',
  '3xl': 'sm:max-w-3xl',
  '4xl': 'sm:max-w-4xl',
  '5xl': 'sm:max-w-5xl'
};
export enum ALERT_VARIANTS {
  DEFAULT = 'default',
  WARNING = 'warning',
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
}
export type AlertVariant = `${ALERT_VARIANTS}`;
const colors = {
  [ALERT_VARIANTS.DEFAULT]: 'border border-borderPrimary',
  [ALERT_VARIANTS.WARNING]: 'border border-contentYellow',
  [ALERT_VARIANTS.SUCCESS]: 'border border-contentGreen',
  [ALERT_VARIANTS.ERROR]: 'border border-contentRed',
  [ALERT_VARIANTS.INFO]: 'border border-contentBlue'
};
const AlertVariantContext = createContext<AlertVariant>(ALERT_VARIANTS.DEFAULT);
export const useAlertVariant = () => {
  return useContext(AlertVariantContext);
};
export function Alert(t0) {
  const $ = _c(21);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      size: t1,
      type: t2,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const size = t1 === undefined ? "md" : t1;
  const type = t2 === undefined ? "default" : t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Headless.DialogBackdrop transition={true} className={cn("fixed inset-0 flex w-screen justify-center overflow-y-auto bg-zinc-950/15 px-2 py-2 transition duration-100 focus:outline-0 data-closed:opacity-0 data-enter:ease-out data-leave:ease-in sm:px-6 sm:py-8 lg:px-8 lg:py-16 dark:bg-zinc-950/50")} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = colors[type];
  const t5 = sizes[size];
  let t6;
  if ($[7] !== className || $[8] !== t4 || $[9] !== t5) {
    t6 = cn(t4, t5, "row-start-2 w-full rounded-2xl bg-backgroundPrimary p-8 shadow-lg ring-1 ring-zinc-950/10 sm:rounded-2xl sm:p-6 dark:bg-zinc-900 dark:ring-white/10 forced-colors:outline", "transition duration-100 will-change-transform data-closed:data-enter:scale-95 data-closed:opacity-0 data-enter:ease-out data-leave:ease-in", className);
    $[7] = className;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== t6 || $[13] !== type) {
    t7 = <div className="fixed inset-0 w-screen overflow-y-auto pt-6 sm:pt-0"><div className="grid min-h-full grid-rows-[1fr_auto_1fr] justify-items-center p-8 sm:grid-rows-[1fr_auto_3fr] sm:p-4"><Headless.DialogPanel data-variant={type} transition={true} className={t6}>{children}</Headless.DialogPanel></div></div>;
    $[11] = children;
    $[12] = t6;
    $[13] = type;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== props || $[16] !== t7) {
    t8 = <Headless.Dialog {...props}>{t3}{t7}</Headless.Dialog>;
    $[15] = props;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8 || $[19] !== type) {
    t9 = <AlertVariantContext.Provider value={type}>{t8}</AlertVariantContext.Provider>;
    $[18] = t8;
    $[19] = type;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}